/**
 * Where a help article lives.
 *
 * WHY THIS IS SHARED. The website's help primitives built this URL inline in
 * `packages/ui/src/components/help-primitives.tsx`, so the native app had two
 * options: hardcode the same string, or ship no in-app help at all. It shipped
 * no help.
 *
 * The base is not a constant that will stay put, which is what makes a second
 * copy dangerous rather than merely untidy: Module #35 gives tenants their own
 * white-label help domain, and when that lands every caller has to move
 * together. One function is the only way that happens.
 */

const HELP_BASE_URL = 'https://help.auctisync.com';

/**
 * Canonical URL for a help article.
 *
 * Slugs are authored by us and appear in code, never in user input — but a
 * slug with a slash or a scheme in it would silently produce a link pointing
 * somewhere else entirely, so it is rejected rather than encoded into
 * something that merely looks wrong.
 */
export function helpArticleUrl(slug: string): string {
  const clean = slug.trim();
  if (clean === '' || /[^a-z0-9-]/i.test(clean)) {
    throw new Error(
      `Invalid help slug ${JSON.stringify(slug)} — expected lowercase words separated by hyphens.`,
    );
  }
  return `${HELP_BASE_URL}/a/${clean}`;
}
